export default "__VITE_PUBLIC_ASSET__d17abd0d__"